export class Stores {
	fetchStores = () => {
		return new Promise((resolve, reject) => {
			fetch('/crm/stores', {
				method: 'GET'
			})
				.then(storesResp => storesResp.json()
					.then(stores => {
						resolve(stores)
					})
				)
		})
	}
}